const initState = {
  amount: null,
  id: null,
  wallet_log: [],
  loading: false,
  cashBackData: "",
  lastDocument: "",
  hasMoreDocument: true,
  transactions: [],
  limitExceeded: false,
};
const walletReducer = (state = initState, action) => {
  switch (action.type) {
    case "CHECK_CASH_BACK_ID":
      return {
        ...state,
        cashBackData: action.payload,
      };
    case "FETCH_WALLET": {
  const p = action.payload ?? {};
  return {
    ...state,
    amount: p.amount ?? 0,
    id: p.id ?? null,
  };
}

    case "FETCH_WALLET_LOGS":
      return {
        ...state,
        wallet_log: action.payload.data,
        lastDocument: action.payload.lastDocument,
        hasMoreDocument: action.payload.hasMoreDocument,
      };
    case "MORE_FETCH_WALLET_LOGS":
      return {
        ...state,
        wallet_log: [...state.wallet_log, ...action.payload.data],
        lastDocument: action.payload.lastDocument,
        hasMoreDocument: action.payload.hasMoreDocument,
      };
    case "SET_IS_LOADING":
      return {
        ...state,
        loading: action.payload,
      };
    case "SET_COINS_STATS":
      return {
        ...state,
        transactions: action.payload,
      };
    case "SET_COINS_STATS_LIMIT":
      return {
        ...state,
        limitExceeded: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};
export default walletReducer;
